import "./val.css"

function Home() {
  return (
    <>
    <div className="spacing3"></div>
    <img src="val.jpeg" className="mernimg"></img>
    <div className="spacing3"></div>
    </>
  );
}

export default Home;
